<template>
  <div class="thread-row-skeleton px-1 pt-2 pb-1" data-qa="thread-skeleton">
    <div class="d-flex">
      <v-skeleton-loader class="thread-row-skeleton__avatar mr-3" type="avatar" />
      <div class="flex-grow-1 thread-row-skeleton__content">
        <div class="thread-row-skeleton__line d-flex justify-space-between align-center">
          <v-skeleton-loader class="thread-row-skeleton__bone w-50" type="text" />
          <v-skeleton-loader class="thread-row-skeleton__bone thread-row-skeleton__bone--short ml-4" type="text" />
        </div>
        <div class="thread-row-skeleton__line d-flex align-center mt-2">
          <v-skeleton-loader class="thread-row-skeleton__bone w-75" type="text" />
        </div>
      </div>
    </div>
    <div class="thread-row-skeleton__line d-flex justify-space-between align-center mt-2">
      <v-skeleton-loader class="thread-row-skeleton__bone w-33" type="text" />
      <v-skeleton-loader class="thread-row-skeleton__bone thread-row-skeleton__bone--short ml-4" type="text" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.thread-row-skeleton {
  border-bottom: 1px solid #e0e0e0;

  &:first-child {
    border-top: 1px solid #e0e0e0;
  }

  &__content {
    min-width: 0;
  }

  &__line {
    height: 24px;
  }

  &__avatar {
    flex: 0 0 44px;
    width: 44px;
    height: 44px;

    :deep(.v-skeleton-loader__avatar) {
      width: 44px;
      min-width: 44px;
      max-width: 44px;
      height: 44px;
      min-height: 44px;
      max-height: 44px;
      margin: 0;
    }
  }

  &__bone {
    :deep(.v-skeleton-loader__text) {
      width: 100%;
      margin: 0;
    }

    &--short {
      flex: 0 0 48px;
      width: 48px;
    }
  }

  .v-skeleton-loader {
    background: transparent;
  }
}
</style>
